import { render } from "./PolicyView.vue?vue&type=template&id=c12f93ac&scoped=true"
const script = {}

import "./PolicyView.vue?vue&type=style&index=0&id=c12f93ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12f93ac"]])

export default __exports__